
import throttle from 'lodash/throttle'
export default {
  inserted: function (el, binding, vnode) {
    const elm = vnode.componentInstance.staticList.elm.parentElement
    elm.onscroll = function () {
      if (elm.scrollHeight - elm.scrollTop === elm.clientHeight) {
        console.log('scroll end')
        vnode.componentInstance.$emit('scrollend')
      }
    }
  },
  unbind: function (el, binding, vnode) {

  }
}
